import { generateTypes } from '../../utils/HttpReducerHelper';

export const reportEntities = generateTypes('USER_REPORT', 'REPORT_ENTITIES');
